"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var adaptive_1 = __importDefault(require("./adaptive"));
var Small = function (_a) {
    var fill = _a.fill, title = _a.title, background = _a.background, rest = __rest(_a, ["fill", "title", "background"]);
    return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 380 380", version: "1.1" }, rest),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("circle", { cx: "190", cy: "190", r: "190", fill: fill }),
        react_1.default.createElement("g", { fill: "#ffffff" },
            react_1.default.createElement("path", { d: "M 77.9998 247.15 C 36.9998 247.15 19.6998 225.95 19.6998 189.85 C 19.6998 153.75 36.7998 132.85 77.9998 132.85 C 119.2 132.85 136.2 153.75 136.2 189.85 C 136.2 226.35 119.2 247.15 77.9998 247.15 Z M 77.9998 160.65 C 61.3998 160.65 55.9998 167.25 55.9998 189.65 C 55.9998 212.35 61.2998 219.25 77.9998 219.25 C 94.6998 219.25 99.9998 212.15 99.9998 189.65 C 99.8998 167.15 95.0998 160.65 77.9998 160.65 Z" }),
            react_1.default.createElement("path", { d: "M 196.7 214.05 L 183.7 214.05 L 183.7 245.15 L 149.2 245.15 L 149.2 134.55 L 196.6 134.55 C 233.4 134.55 248.5 149.15 248.5 175.25 C 248.6 198.35 233.5 214.05 196.7 214.05 Z M 196.7 160.55 L 183.7 160.55 L 183.7 189.45 L 196.7 189.45 C 208.6 189.45 213.2 186.95 213.2 175.15 C 213.2 163.65 209.2 160.55 196.7 160.55 Z" }),
            react_1.default.createElement("path", { d: "M 308.5 214.05 L 295.5 214.05 L 295.5 245.15 L 261 245.15 L 261 134.55 L 308.4 134.55 C 345.2 134.55 360.3 149.15 360.3 175.25 C 360.4 198.35 345.4 214.05 308.5 214.05 Z M 308.5 160.55 L 295.5 160.55 L 295.5 189.45 L 308.5 189.45 C 320.4 189.45 325 186.95 325 175.15 C 325 163.65 321.1 160.55 308.5 160.55 Z" }))));
};
var Opp = function (props) {
    var _a = props.fill, fill = _a === void 0 ? '#26828a' : _a, rest = __rest(props, ["fill"]);
    return react_1.default.createElement(adaptive_1.default, __assign({ small: Small, fill: fill, shift: -20 }, rest));
};
exports.default = Opp;
